import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import AlarmsNotifications from '../AlarmsNotifications'

const Notifications = (props) => {
  const { toolbar, unChecked } = props
  const { t_ } = useSmartTranslation()

  return (
    <AlarmsNotifications title={t_('Notifications')} state='NOTIFICATIONS' unChecked={unChecked} toolbar={toolbar} />
  )
}
export default Notifications
